module.exports = __webpack_public_path__ + "static/media/monkey.795a8775.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/monkey.gif
// module id = 357
// module chunks = 0